<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    :showIsAssign="true"
    :showInputCheck="true"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}文字題
    </template>
    <v-card-text slot="content" class="text-start">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">{{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}</div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        auto-grow
        label="題目內容"
        v-model="ques.cnName"
        v-on:click="checkDef()"
        class="mt-2 peter-text"
      ></v-textarea>      
      <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>      
      <v-textarea        
        v-if="!isEdit"
        outlined
        rows="1"
        auto-grow
        label="回答內容"
        v-model="ques.value"
        :maxlength="ques.length"
        class="mt-2 peter-text"
      ></v-textarea>      
      <v-row v-if="isEdit">
        <v-col cols="12" sm="5" md="3">
          <v-text-field
            dense
            label="回答字數限制"
            v-model="ques.length"
            :min="0"
            outlined
            class="centered-input peter-text"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    maxwidth: {
      type: Number,
      default: null,
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '文字題',
          cnName: '文字題題目內容',
          length: 20,
          value: 3,
        }
      },
    },
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    checkDef() {
      if (this.QType.TEXT.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }      
    },
  },
  computed: {
    value() {
      return this.ques.value
    },
    QType() {
      return this.$store.state.QType
    },
  },
  watch: {
    value(newValue, oldValue) {
      let lengthLimit = this.ques.length
      if (newValue.length > lengthLimit && lengthLimit >= 0) {
        this.ques.value = newValue.substr(0, lengthLimit)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
</style>
